// Configuración principal de la aplicación Angular
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { correlationIdInterceptor } from './core/interceptors/correlation-id.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { mockApiInterceptor } from '../mocks/mock-api.interceptor';
import { environment } from '../environments/environment';

// Los interceptores base siempre activos
const baseInterceptors = [loadingInterceptor, correlationIdInterceptor, authInterceptor, errorInterceptor];

// El mock interceptor solo se activa en desarrollo local (environment.useMocks)
const allInterceptors = environment.useMocks
  ? [...baseInterceptors, mockApiInterceptor]
  : baseInterceptors;

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors(allInterceptors)),
  ],
};
